import { taskInRun } from './taskRuns'

function hasArtifact(blocks = []) {
  return blocks.some((block) => block?.type === 'artifact_card')
}

function runTasks(run) {
  return (run.workStatus?.tasks ?? []).filter((task) => taskInRun(run.runId, task))
}

function workIsStillOpen(tasks) {
  return tasks.some((task) => ['pending', 'in_progress', 'waiting'].includes(task.status))
}

export function phase1ThoughtSummary(run) {
  const tasks = runTasks(run)
  if (hasArtifact(run.blocks)) return 'Document ready'
  if (run.status === 'error') return 'Stream failed'
  if (run.status === 'done') {
    if (workIsStillOpen(tasks)) return tasks.some((task) => task.status === 'waiting')
      ? 'Waiting for approval or input' : 'Response ready; work still in progress'
    return tasks.length ? 'Work completed' : 'Response ready'
  }
  const task = tasks.find((item) => item.status === 'in_progress')
  if (task?.detail || task?.title) return task.detail ?? task.title
  const active = run.activity.find((item) => item.status === 'running')
  if (active?.label) return active.label
  return run.text ? 'Writing answer...' : 'Starting stream...'
}
